<template>
    <ModalBase @close="e => $emit('close', e)" :withContent="true">
        <h1>{{ $trad.plano.editor.header.help.shortcutList.label }}</h1>
        <ul>
            <fragment v-for="shortcut in Object.keys(shortcuts)" :key="shortcut">
                <label>{{ $trad.plano.editor.header.help.shortcutList[shortcut] }}</label>
                <li>
                    <strong v-for="(char, i) in shortcuts[shortcut]" :key="i">{{ char }}</strong>
                </li>
            </fragment>
        </ul>
    </ModalBase>
</template>

<script>
import ModalBase from "@/components/modal/ModalBase";
import { isMac } from "@/utils/platform";

const CMD = "⌘";
const CTRL = "ctrl";

const ACTION = isMac ? CMD : CTRL;

export default {
    components: { ModalBase },
    data: () => ({
        shortcuts: {
            "zoom+": [ACTION, "+"],
            "zoom-": [ACTION, "-"],
            copy: [ACTION, "C"],
            paste: [ACTION, "V"],
            save: [ACTION, "S"],
            undo: [ACTION, "Z"],
            redo: [ACTION, "Y"],
            delete: ["⌫"],
            edit: [ACTION, "E"],
            addToFavorites: [ACTION, "F"],
            group: [ACTION, "G"],
            ungroup: [ACTION, "U"],
            print: [ACTION, "P"],
            magnet: [ACTION, "M"],
            toggleLayers: [ACTION, "L"],
            toggleLibrary: [ACTION, "B"]
        }
    })
};
</script>

<style scoped lang="scss">
ul {
    width: 500px;
    display: grid;
    padding: unset;
    grid-template-columns: 1fr auto 1fr auto;
    grid-row-gap: 10px;
    grid-column-gap: 10px;
    flex-direction: column;
    align-content: center;
    align-items: center;

    label {
        text-align: end;
    }

    li {
        display: grid;
        grid-auto-flow: column;
        justify-content: start;
        align-items: center;
    }
}
strong + strong {
    margin-left: 10px;
}
strong {
    display: flex;
    justify-content: center;
    border: 1px solid grey;
    border-radius: 5px;
    padding: 5px;
    min-width: 28px;
}
</style>



// WEBPACK FOOTER //
// shortcuts.vue?9ab757cc